import * as React from "react";

const Version: React.FC = () => {
  return <>1.38.2 </>;
};

export default Version;
